import { render, staticRenderFns } from "./AttributesMain.vue?vue&type=template&id=7074bbbc&scoped=true&"
import script from "./AttributesMain.vue?vue&type=script&lang=js&"
export * from "./AttributesMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7074bbbc",
  null
  
)

export default component.exports